import { render } from "./UsuariosList.vue?vue&type=template&id=2155f036&scoped=true"
import script from "./UsuariosList.vue?vue&type=script&lang=js"
export * from "./UsuariosList.vue?vue&type=script&lang=js"

import "./UsuariosList.vue?vue&type=style&index=0&id=2155f036&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2155f036"]])

export default __exports__